/* ============
 * State of formalities module
 * ============
 *
 * The initial state of the formalities module.
 */

export default {
  maxAmount: null
}



// WEBPACK FOOTER //
// ./src/store/modules/endorsements/state.js